export enum DisplayNames {
  Input = 'Input',
  InputGroup = 'InputGroup',
  InputLeftAddon = 'InputLeftAddon',
  InputRightAddon = 'InputRightAddon',
  InputLeftElement = 'InputLeftElement',
  InputRightElement = 'InputRightElement'
}

export enum InputMaskTypes {
  Phone = 'phone',
  CreditCard = 'creditCard',
  CreditCardExpiry = 'creditCardExpiry',
  SSN = 'ssn',
  Currency = 'currency',
  Custom = 'custom'
}
